<div class="kamishibai-board">
  <table mat-table [dataSource]="dataSource" class="kamishibai-table p-1">
    <!-- Group Column -->
    <ng-container matColumnDef="group">
      <th mat-header-cell *matHeaderCellDef style="position: sticky; left: 0; z-index: 1">{{ monthText }}</th>
      <td
        mat-cell
        *matCellDef="let element"
        [attr.rowspan]="element.rowSpan"
        [style.display]="element.rowSpan ? '' : 'none'"
        style="
          background-color: #838c9e;
          color: #fff;
          font-weight: 700;
          border-radius: 5px;
          text-align: center;
          width: 100px;
          position: sticky;
          left: 0;
          z-index: 1;
        "
        class="group-cell"
      >
        {{ 'system.label.dateRanges.' + element.group | translate }}
      </td>
    </ng-container>

    <!-- Dynamic Date Columns -->
    <ng-container *ngFor="let date of uniqueDates; let i = index" [matColumnDef]="date">
      <th mat-header-cell *matHeaderCellDef class="p-1">
        <div class="header-card" [class.today]="today === (date | dateFormat: dayFormat)">
          {{ date | dateFormat: (isSimpleCardMode ? 'D ddd' : 'D dddd') }}
        </div>
      </th>
      <td
        mat-cell
        *matCellDef="let element"
        [class.highlight]="element[date]"
        [style.background-color]="i % 2 === 0 ? 'white' : '#fafafa'"
        style="width: 100px"
      >
        <app-kamishibai-card
          *ngIf="element[date]"
          [item]="element[date]"
          [isSimpleMode]="isSimpleCardMode"
          (refreshDashboard)="refreshDashboard()"
        ></app-kamishibai-card>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
